import type { LucideIcon } from "lucide-react";
import type { ComponentType, SVGProps } from "react";

export interface NavSubItem {
	title: string;
	href: string;
	configKey?: string;
	isAccessible?: boolean;
}

export interface NavItem {
	title: string;
	href: string;
	icon: LucideIcon | ComponentType<SVGProps<SVGSVGElement>>;
	internal?: boolean;
	isActive?: boolean;
	configKey?: string | string[];
	isAccessible?: boolean;
	subItems?: NavSubItem[];
}

export interface NavbarUser {
	name: string;
	email: string;
	avatar?: string;
}

export interface PartnerNavConfig {
	navbarConfig: string[];
	isSubPartner: boolean;
	isAuthorized: boolean;
	isBookingPartner: boolean;
	isPartnerCustomFormEnabled: boolean;
	isSettingsPageVisible?: boolean;
	partnerName?: string;
}

export interface NavbarProps {
	user?: NavbarUser;
	partnerConfig?: PartnerNavConfig;
	onLogout?: () => void;
	isCollapsed?: boolean;
	onToggleCollapse?: () => void;
}

/**
 * Check if a nav item should be visible based on navbar_config
 * @param configKeys - The config key(s) required for this nav item
 * @param navbarConfig - The navbar_config array from partner API
 * @returns true if all config keys are present in navbar_config
 */
export const showNavItem = (
	configKeys: string | string[],
	navbarConfig: string[],
): boolean => {
	const keys = Array.isArray(configKeys) ? configKeys : [configKeys];
	return keys.every((key) => navbarConfig.includes(key));
};
